"cod_ine","nom","carlist_mean"
"08001","Abrera",0.392927318811417
"08002","Aguilar de Segarra",22.2945673465729
"08003","Alella",3.85260851383209
"08004","Alpens",20.9617637563497
"08005","L'Ametlla del Vallès",9.94812124967575
"08006","Arenys de Mar",10.9066938042641
"08007","Arenys de Munt",16.2482563018799
"08008","Argençola",26.4706241819594
"08009","Argentona",6.61295211315155
"08010","Artés",10.6686711419712
"08011","Avià",25.6889558434486
"08012","Avinyó",16.0346230918711
"08013","Avinyonet",5.02505294084549
"08014","Aiguafreda",19.7110350264443
"08015","Badalona",5.86654782295227
"08016","Bagà",19.9499592781067
"08017","Balenyà",34.2919250528018
"08018","Balsareny",17.1905870914459
"08019","Barcelona",5.61193402246995
"08020","Begues",4.29864263534546
"08021","Bellprat",25.7118425965309
"08022","Berga",27.1484482586384
"08023","Bigues",22.8599791526794
"08024","Borredà",24.210747256875
"08025","Bruc",18.3823015722964
"08026","Brull",30.6856454610825
"08027","Les Cabanyes",0.472974026203156
"08028","Cabrera d'Igualada",16.5943172454834
"08029","Cabrera de Mataró",5.24193158149719
"08030","Cabrils",9.92739939689636
"08031","Calaf",27.7379737430149
"08032","Caldes d'Estrac",8.16581802368164
"08033","Caldes de Montbui",6.65062898728583
"08034","Calders",10.7595355510712
"08035","Calella",11.8368648767471
"08036","Calonge de Segarra",31.1749277114868
"08037","Sant Martí de Riudeperes",40.0144906361898
"08038","Callús",18.903458327055
"08039","Campins",27.9538311004639
"08040","Canet de Mar",11.3504876613617
"08041","Canovelles",22.7765691280365
"08042","Cànoves",14.4614075819651
"08043","Canyelles",2.34113717079163
"08044","Capellades",20.3585531446669
"08045","Capolat",26.9511279165745
"08046","Cardedeu",10.6016101439794
"08047","Cardona",16.4659598171711
"08048","Carme",12.7245352036423
"08049","Casserres",22.76264077425
"08050","Castellar del Riu",8.45921779796481
"08051","Castellar",
"08052","Castellar de n'Hug",19.8215877115727
"08053","Castellbell",16.0873291492462
"08054","Castellbisbal",
"08055","Castellcir",20.2913760940234
"08056","Castelldefels",0
"08057","Castell de l'Areny",27.8614903688431
"08058","Castellet",5.21945428848267
"08059","Castellfollit del Boix",12.3998043358326
"08060","Castellfollit de Riubregós",20.8951105541653
"08061","Castellgalí",24.9886611938477
"08062","Castellnou de Bages",11.0539708375931
"08063","Castellolí",12.89790885316
"08064","Castellterçol",29.5785649617513
"08065","Castellví de la Marca",8.96624183654785
"08066","Castellví de Rosanes",2.05479454994202
"08067","Centelles",19.8079007538882
"08068","Cervelló",0.931677043437958
"08069","Collbató",16.7223471270667
"08070","Collsuspina",15.2087539434433
"08071","Copons",14.2247388288379
"08072","Corbera de Llobregat",1.67224085330963
"08073","Cornellà",4.72440958023071
"08074","Cubelles",4.5325779914856
"08075","Dosrius",4.73339660465717
"08076","Esparreguera",0.597701132297516
"08077","Esplugues",5.59999990463257
"08078","Espunyola",20.274242396156
"08079","Estany",24.236728811264
"08080","Fígols",23.9343109130859
"08081","Fogars de Montclús",16.9167225261529
"08082","Fogars de Tordera",25.8750736713409
"08083","Folgueroles",41.4856080412865
"08084","Fonollosa",14.6369286775589
"08085","Fontrubí",4.49580795764923
"08086","Les Franqueses del Vallès",14.6449390411377
"08087","Gallifa",42.0171826680501
"08088","La Garriga",15.4005361398061
"08089","Gavà",1.57303369045258
"08090","Gaià",17.2731065988541
"08091","Gelida",1.01867568492889
"08092","Gironella",26.4193279966712
"08093","Gisclareny",34.4346963912249
"08094","La Granada",13.3447884082794
"08095","Granera",14.1918715563687
"08096","Granollers",13.2690992355347
"08097","Gualba",15.1426509857178
"08098","Guardiola",29.229418951273
"08100","Gurb",52.3661286830902
"08101","l'Hospitalet",0.136798903346062
"08102","Igualada",25.073403623369
"08103","Jorba",32.2418026394314
"08104","La Llacuna",21.8246833483378
"08106","Llinars",12.9262014230092
"08107","Lliçà de Munt",8.48725175857544
"08108","Lliçà de Vall",6.50701442360878
"08109","Lluçà",21.7695837020874
"08110","Malgrat",8.27877268195152
"08111","Malla",43.9452676971754
"08112","Manlleu",32.8737894892693
"08113","Manresa",18.6729064464569
"08114","Martorell",1.91605842113495
"08115","Martorelles",17.6326723098755
"08116","Masies de Roda",31.1511948664983
"08117","Masies de Sant Hipòlit de Voltregà",35.1890897005796
"08118","Masnou",2.76763758659363
"08119","Masquefa",6.28836326599121
"08120","Matadepera",
"08121","Mataró",4.54482039213181
"08122","Mediona",2.18704645633698
"08123","Molins de Rei",4.22386503219605
"08124","Mollet",9.30440034866333
"08125","Montcada i Reixac",
"08127","Monistrol de Montserrat",19.7548663139343
"08129","Muntanyola",43.9230312108994
"08130","Montclar de Berga",26.9644627571106
"08132","Montmajor",28.7422485351563
"08133","Montmaneu",10.7771206299464
"08134","Montmany",11.5589332580566
"08135","Montmeló",16.3877198298772
"08136","Montornès del Vallès",18.7639168898265
"08137","Montseny",14.1453635692596
"08138","Moià",20.0508755770597
"08139","Mura",18.574530929327
"08140","Navarcles",8.85124595165253
"08141","Castelladral",22.1520268917084
"08142","La Nou",26.5413473844528
"08143","Òdena",20.5303547117445
"08144","Olvan",37.6432288885117
"08145","Olèrdola",7.18404860496521
"08146","Olesa de Bonesvalls",0
"08147","Olesa de Montserrat",
"08148","Olivella",0
"08149","Olost",23.4974950551987
"08150","Orís",38.4330952465534
"08151","Oristà",36.1542979649135
"08152","Orpí",26.3401001029544
"08153","Orrius",7.74817981719971
"08154","Pacs del Penedès",10.5834442138672
"08155","Palafolls",17.5067139029503
"08156","Palausolità",
"08157","Pallejà",3.43347644805908
"08158","El Papiol",2.81690144538879
"08159","Parets del Vallès",10.6584716041883
"08160","Perafita",31.9898116588593
"08161","Piera",9.01246795654297
"08162","Pierola",6.64685193697612
"08163","Pineda",12.8712890148163
"08164","Pla del Penedès",3.5839955329895
"08165","Pobla de Claramunt",19.4276822937859
"08166","Pobla de Lillet",18.9219906330109
"08167","Polinyà",
"08168","Pontons",5.41603736877441
"08169","Prat del Llobregat",3.80348658561707
"08170","Prats de Rei",27.47585105896
"08171","Prats de Lluçanès",15.560322035104
"08172","Premià de Mar",4.68083267211914
"08173","Pruit",40.2219475547473
"08174","Puigdalba",12.5115594863892
"08175","Puig-reig",21.4885820001364
"08176","Pujalt",20.7169385486179
"08177","La Quart",31.0403367822821
"08178","Rajadell",17.4559305667877
"08179","Rellinars",
"08180","Ripollet",
"08181","La Roca del Vallès",18.8246084054311
"08182","Rocafort i Vilomara",12.1716486716812
"08183","Roda",18.0028066914529
"08184","Rubí",
"08185","Rubió",37.3607683181763
"08186","Sant Joan de Fàbregas",30.9943425655365
"08187","Sabadell",0.567375898361206
"08188","Sagàs",34.495418548584
"08189","Sallavinera",34.5866673787435
"08190","Saldes",9.96250253915787
"08191","Sallent",9.31356500387192
"08192","Santpedor",10.3450579226017
"08193","Sant Iscle de Vallalta",12.8450944423676
"08194","Sant Adrià de Besòs",13.648261460391
"08195","Sant Agustí de Lluçanès",31.9254219348614
"08196","Sant Andreu de la Barca",9.76253318786621
"08197","Sant Andreu de Llavaneres",4.69101005792618
"08198","Sant Antoni de Vilamajor",14.1528090834618
"08199","Sant Bartomeu del Grau",38.5690951645374
"08200","Sant Boi de Llobregat",7.08333349227905
"08201","Sant Boi de Lluçanès",28.7822135516575
"08202","Sant Celoni",14.5515063047409
"08203","Sant Cebrià de Vallalta",11.1381548881531
"08204","Sant Climent de Llobregat",4.26356601715088
"08205","Sant Cugat del Vallès",
"08206","Sant Cugat Sesgarrigues",1.61268036365509
"08207","Sant Esteve de Palautordera",18.6958337783814
"08208","Sant Esteve Sesrovires",0
"08209","Sant Fost de Campsentelles",13.2872896989187
"08210","Sant Feliu de Codines",9.80195128917694
"08211","Sant Feliu de Llobregat",5.62625598907471
"08212","Sant Feliu Sasserra",18.7865479171276
"08213","Sant Fruitós de Bages",8.61649013161659
"08214","Sant Genís de Vilassar",13.6556141853333
"08215","Sant Hipòlit de Voltregà",29.8949350006878
"08216","Sant Jaume de Frontanyà",31.2058063915798
"08217","Sant Joan Despí",0
"08218","Sant Martí de Torruella",12.8453872084618
"08219","Sant Joan de Vilassar",7.6067795753479
"08221","Sant Just Desvern",2.14132761955261
"08222","Sant Llorenç d'Hortons",0.476190477609634
"08223","Sant Llorenç Savall",22.7546730438868
"08224","Sant Martí de Centelles",20.844365482529
"08225","Sant Martí del Bas",11.5258665800095
"08226","Sant Martí de Tous",31.2945922745599
"08227","Sant Martí Sarroca",12.6363576253255
"08228","Sant Martí Sesgueioles",16.1733863949776
"08229","Sant Mateu de Bages",12.7588016192118
"08230","Sant Pere de Premià",1.28929044008255
"08231","Sant Pere de Ribes",1.94300520420075
"08232","Sant Pere de Riudebitlles",3.12577276229858
"08233","Sant Pere de Torelló",38.4323907308281
"08234","Sant Pere de Vilamajor",21.6803712844849
"08235","Sant Pol de Mar",13.2279093503952
"08236","Sant Quintí de Mediona",1.91776345670223
"08237","Sant Quirze de Besora",29.069621026516
"08238","Sant Quirze del Vallès",
"08239","Sant Quirze Safaja",14.1289508342743
"08240","Sant Sadurní d'Anoia",3.07415210306644
"08241","Sant Sadurní d'Osormort",40.9145204544067
"08242","Santa Cecília de Montserrat",25.0011875364516
"08243","Santa Cecília de Voltregà",38.7285429080327
"08244","Santa Coloma de Cervelló",0
"08245","Santa Coloma de Gramanet",1.48270177841187
"08246","Santa Eugènia de Berga",18.1698370196603
"08247","Santa Eulàlia de Riuprimer",23.788867632548
"08248","Santa Eulàlia de Ronçana",16.5569135348002
"08249","Santa Fe del Penedès",3.79617912769318
"08250","Santa Margarida de Montbui",31.5935902065701
"08251","Santa Margarida i els Monjos",6.19023704528809
"08252","Santa Maria de Barberà",
"08253","Santa Maria de Besora",52.1865452528
"08254","Santa Maria del Corcó",45.46545955113
"08255","Santa Maria de Merlés",28.5430724024773
"08257","Santa Maria de Miralles",26.2094851202435
"08258","Santa Maria d'Oló",19.0015990083868
"08259","Santa Maria de Palautordera",16.6696816444397
"08260","Santa Perpètua de la Moguda",
"08261","Santa Susanna",15.1998841762543
"08262","Sant Vicenç de Castellet",11.0885458320379
"08263","Sant Vicenç dels Horts",7.5268816947937
"08264","Sant Vicenç de Llavaneres",8.80523567199707
"08265","Sant Vicenç de Torelló",30.014526527375
"08266","Cerdanyola",
"08267","Sentmenat",
"08268","Cercs",13.5510670766234
"08269","Seva",38.3156655311584
"08270","Sitges",6.77120447158814
"08271","Sobremunt",53.3609642028809
"08272","Sora",33.8111724938665
"08273","Subirats",10.1408492565155
"08274","Súria",16.9548042774201
"08275","Tavèrnoles",40.2618881165981
"08276","Tagamanent",26.8968280156453
"08277","Talamanca",16.2771627902985
"08278","Taradell",13.9223219950994
"08279","Terrassa",1.15848004817963
"08280","Tavertet",43.4261270840963
"08281","Teià",4.09337114393711
"08282","Tiana",4.75046426653862
"08283","Tona",18.5320984919866
"08284","Tordera",20.5856283783913
"08285","Torelló",31.2686088979244
"08286","Torre de Claramunt",28.6216466128826
"08288","Torrelles de Foix",2.80784952640533
"08289","Torrelles de Llobregat",0.177304968237877
"08290","Ullastrell",
"08291","Vacarisses",
"08292","Vallbona",8.77527084350586
"08293","Vallcebre",22.6747830808163
"08294","Vallgorguina",27.2122116088867
"08295","Vallirana",0.677966117858887
"08297","Veciana",18.7974147266812
"08298","Vic",34.6611787676811
"08299","Vilada de Guardiolans",26.9407156258822
"08300","Viladecavalls",
"08301","Viladecans",2.93609666824341
"08302","Vilanova del Camí",12.1268452033401
"08303","Vilanova de Sau",42.90902856191
"08304","Vilobí",6.51914085149765
"08305","Vilafranca del Penedès",4.86579203605652
"08306","Vilalba Sasserra",19.3366588592529
"08307","Vilanova i la Geltrú",11.3921060562134
"08308","Viver i Serrateix",31.6716202795506
"08506","Horta",1.23809521794319
"08522","Sant Vicenç de Sarrià",10.2507331106398
"08521","Santa Creu d'Olorda",0
"08511","Orsavinyà",23.4567901611328
"08518","Sant Pere de Terrassa",19.2061462402344
"08509","Montnegre",18.6581541061401
"08510","Olzinelles",26.6637062072754
"08512","Palou",11.1339402794838
"08507","Lavit",6.3343380689621
"08524","Terrassola",2.45150661468506
"08508","Masies de Sant Pere de Torelló",48.6113440990448
"08523","Sentfores",29.0098584493001
"08527","Vilalleons",37.175795952479
"08528","Vilatorta",41.7138041178385
"08501","Sant Andreu de la Bola",42.0410956700643
"08517","Sant Martí Sescorts",44.2022785186768
"08513","Salcelles",41.2912901242574
"08525","Valldan",27.7741620615125
"08500","Baells",22.7497397214174
"08502","Brocà",28.6591648086906
"08516","Sant Julià de Cerdanyola",10.3375953994691
"17001","Agullana",15.4358130455017
"17002","Aiguaviva",34.6171375274658
"17003","Albanyà",33.5156694518195
"17004","Albons",6.25287144000714
"17005","Alfar",8.54658731818199
"17006","Alp",12.7987459935248
"17007","Amer",19.8617674052715
"17008","Anglès",31.1718070348104
"17009","Arbúcies",13.8515200614929
"17010","Argelaguer",34.1464276696955
"17011","Armentera",8.58985989827376
"17012","Avinyonet de Puigventós",13.9330909729004
"17013","Begur",4.37125796079636
"17014","La Vajol",9.40121039748192
"17015","Banyoles",17.3802960469173
"17016","Bàscara",30.0851940267226
"17017","Batet",58.9137540544782
"17018","Bellcaire d'Empordà",5.59429689095571
"17019","Besalú",43.9318602255413
"17020","Bescanó",33.3129629731178
"17021","Beuda",18.8251348733902
"17022","La Bisbal",6.86653971672058
"17023","Blanes",3.48749538883567
"17024","Bolvir",15.2236609458923
"17025","Bordils",13.4963658406184
"17026","Borrassà",40.7707822587755
"17027","Breda",16.8975650072098
"17028","Brunyola",49.8839120229085
"17029","Boadella",20.8715995788574
"17030","Cabanes",23.8789173126221
"17031","Cabanelles",39.6179201338026
"17032","Cadaqués",19.3211132420434
"17033","Caldes de Malavella",31.0010664621989
"17034","Calonge",3.33649849891663
"17035","Sant Vicenç de Camós",23.1763140313766
"17036","Sant Cristòfor de Campdevànol",12.2106024324894
"17037","Campelles",18.8178887367249
"17038","Campllong",14.8118585765362
"17039","Camprodon",11.0673786401749
"17040","Canet d'Adri",28.9400835598216
"17041","Cantallops",17.8247088432312
"17042","Capmany",16.8678941726685
"17043","Queralbs",6.71146292984486
"17044","Cassà de la Selva",9.64181835055351
"17045","Castell d'Empordà",1.9736841917038
"17046","Castellfollit de la Roca",31.6869993891035
"17047","Castelló d'Empúries",30.1825176874797
"17048","Castell d'Aro",8.38345861434937
"17049","Celrà",6.18315109839806
"17050","Cervià de Ter",9.59656637448531
"17051","Cistella",27.3817306518555
"17052","Siurana",13.294196665287
"17053","Sant Miquel de Cladells",29.012512922287
"17055","Colomers",13.4977481265863
"17056","Cornellà de Terri",21.3200933016264
"17057","Corçà",10.4955458641052
"17058","Crespià",53.0281136830648
"17059","Cruïlles",28.7064065933228
"17060","Darnius",25.456392288208
"17061","Das",8.79985719919205
"17062","L'Escala",3.75846140201275
"17063","Espinelves",23.346197783947
"17064","Espolla",15.5179351806641
"17065","Esponellà",22.621343429272
"17066","Figueres",9.92742700576782
"17067","Flaçà",14.8584958956792
"17068","Foixà",21.9047622680664
"17070","Fontanilles",12.3711338043213
"17071","Fontcoberta",20.8335321866549
"17072","Fonteta",5.80985927581787
"17073","Fornells de la Selva",17.0860325694084
"17074","Fortià",15.7428123474121
"17075","Garrigàs",32.1877794265747
"17076","Garrigoles",7.73901577179249
"17077","Garriguella",11.85017619133
"17078","Ger",6.56555012294224
"17079","Girona",17.0554054498673
"17080","Gombrèn",16.3507064133883
"17081","Gualta",24.6636772155762
"17082","Guils de Cerdanya",11.0153358206153
"17083","Hostalric",14.3550022095442
"17084","Isòvol",7.06958711147308
"17085","Jafre",10.2882318038207
"17086","La Jonquera",15.5216804981232
"17087","Juià",13.2930828241202
"17088","Lladó",37.2036108440823
"17089","Llagostera",4.50384747449841
"17090","Llambilles",7.89714348912239
"17091","Llanars",9.65380643308163
"17092","Llançà",2.28610499203205
"17093","Llers",27.5941867828369
"17094","Llívia",5.73563852906227
"17095","Lloret de Mar",5.87779784947634
"17096","Les Lloses",23.9254771471024
"17097","Madremanya",15.258622609652
"17098","Maià de Montcal",42.4244414057051
"17099","Meranges",4.91720519587398
"17100","Massarac",14.3128033638001
"17101","Massanes",16.1401083469391
"17102","Maçanet de Cabrenys",10.7551167964935
"17103","Maçanet de la Selva",13.4204944968224
"17104","Medinyà",21.478548673483
"17105","Mieres",54.7677456992013
"17106","Mollet de Peralada",11.887749350071
"17107","Molló",16.7666531801224
"17108","Monells",48.6385316848755
"17109","Montagut",24.3833760023117
"17110","Mont-ras",15.7231178283691
"17111","Navata",41.2877733442519
"17112","Ogassa",7.49230662733316
"17113","Oix",19.3947737812996
"17114","Olot",42.3704172543117
"17115","Ordis",31.0022081798977
"17116","Osor",20.8657231648763
"17117","Palafrugell",9.67022562026978
"17118","Palamós",8.10043597221375
"17119","Palau de Santa Eulàlia",33.0828680594762
"17120","Palau-saverdera",24.0614317920473
"17121","Palau-sator",29.6858973503113
"17122","Palmerola",15.7839076519013
"17123","Palol de Revardit",29.5953571095186
"17124","Pals",22.5828261375427
"17125","Pardines",10.3621999323368
"17126","Parlavà",29.5566501617432
"17127","Parroquia de Ripoll",13.034373357892
"17128","Pau",21.6079962650935
"17130","La Pera",31.7991638183594
"17131","Peratallada",8.5427131652832
"17132","Perelada",27.4070233239068
"17133","les Planes d'Hostoles",38.8436213220869
"17134","Planoles",7.62255647778511
"17135","Pont de Molins",12.8841895580292
"17136","Pontós",42.3020059797499
"17137","Porqueres",39.3269576465382
"17138","Portbou",7.88059960007668
"17139","Sant Pere de les Preses",50.9382856913975
"17140","Port de la Selva",25.3593527442879
"17141","Puigcerdà",7.84466984495521
"17142","Quart",11.5053123831749
"17143","Rabós",12.432112288475
"17144","Regencós",24.8587560653687
"17145","Ribes de Freser",14.0578454732895
"17146","Riells i Viabrea",16.5796707868576
"17147","Ripoll",9.08628864586353
"17148","Riudarenes",20.1467994749546
"17149","Riudaura",26.5183081626892
"17150","Riudellots de la Selva",33.4748561859131
"17151","Riumors",22.4162710375256
"17152","Roses",20.8109147217539
"17153","Rupià",14.9206352233887
"17154","Sales de Llierca",24.2902226448059
"17155","Salt",16.9817010819912
"17156","Sant Andreu de Terri",18.458668250304
"17157","Sant Andreu Salou",25.7717333475749
"17158","Sant Climent Sescebes",14.5575115203857
"17159","Sant Feliu de Buixalleu",18.0260181427002
"17160","Sant Feliu de Guíxols",0.974372625350952
"17161","Sant Feliu de Pallerols",41.2208392279489
"17162","Parròquia de Besalú",57.530567577907
"17163","Sant Gregori",31.1291764483732
"17164","Sant Hilari Sacalm",21.2921017408371
"17165","Palau de Montagut",15.7911522388458
"17166","Sant Jordi Desvalls",22.7715946344229
"17167","Sant Joan de les Abadesses",12.2422567456961
"17168","Sant Joan de Mollet",15.0551435764019
"17169","Sant Julià de Ramis",22.9283860279964
"17170","Vallfogona de Ripollès",16.459688782692
"17171","Sant Llorenç de la Muga",13.609205365181
"17172","Sant Martí de Llémena",28.9819761444541
"17174","Sant Miquel de Campmajor",62.5594557353428
"17175","Sant Miquel de Fluvià",27.8843889766269
"17176","Sant Mori",11.1043021059953
"17177","Sant Pau de Segúries",18.5398690998554
"17178","Sant Pere Pescador",20.0865921080113
"17179","Sant Sadurní",14.4628095626831
"17180","Santa Coloma de Farners",16.1765687465668
"17181","Santa Cristina d'Aro",22.5375938415527
"17182","Santa Llogaia d'Àlguema",7.96918740272522
"17183","Sant Aniol de Finestres",40.3468930380685
"17184","Santa Pau",51.2625338690622
"17185","Begudà",31.5147919825145
"17186","Sarrià de Ter",6.31527995375487
"17187","Saus",17.7407717154576
"17188","Selva de Mar",24.3781601720386
"17189","La Cellera",34.193087832133
"17190","Serinyà",12.826323394592
"17191","Serra de Daró",98.4848480224609
"17192","Setcases",10.2879534959793
"17193","Sils",8.69929310679436
"17194","Susqueda",41.6003050486247
"17195","La Tallada",23.3830852508545
"17196","Terrades",18.2323373794556
"17197","Torrent",13.5964908599854
"17198","Torroella de Fluvià",41.2178379694621
"17199","Torroella de Montgrí",17.7702045440674
"17200","Tortellà",28.107496704374
"17201","Sant Cristòfor de Toses",16.0497913360596
"17202","Tossa",10.6585865020752
"17204","Ullà",34.7560958862305
"17205","Ullastret",75.5395660400391
"17206","Urús",10.1306654065847
"17208","Vall de Bianya",46.4293338230678
"17209","Vall-llòbrega",14.0693116188049
"17210","Ventalló",6.43370810838846
"17211","Verges",6.09437384513708
"17212","Vidrà",22.1643755435944
"17213","Vidreres",9.48621594905853
"17214","Vilabertran",9.21016391515732
"17215","Vilablareix",25.2983191370964
"17216","Viladasens",42.0693199494306
"17217","Viladamat",12.909121123644
"17218","Vilademuls",41.2170146493351
"17219","Viladonja",20.7608467340469
"17220","Viladrau",22.2137227058411
"17221","Vilafant",10.9556437015534
"17222","Vilaür",10.9067728336041
"17223","Vilajuïga",22.7466133435567
"17224","Vilallonga de Ter",17.5985624492168
"17225","Vilamacolum",29.0421010653178
"17226","Vilamalla",16.6999604701996
"17227","Vilamaniscle",6.91392967104912
"17228","Vilanant",24.9623077392578
"17229","Vilanova de la Muga",26.1968057420519
"17230","Vilasacra",13.1813164234161
"17231","Vilatenim",15.7286545038223
"17232","Vilopriu",18.4941207904082
"17233","Vilobí d'Onyar",35.4585142771403
"17234","Biure",15.2849128246307
"17235","Vulpellac",10.0931358337402
"17500","Sant Cristòfor de Baget",14.8496468812227
"","Sant Martí de Querós",32.6040325164795
"17502","Bassegoda",18.2955113053322
"17507","Dosquers",43.2136061986288
"17519","Tarabaus",18.36639585495
"17505","Casavells",16.3551406860352
"17509","Joanetes",53.5678003856114
"17514","Sant Joan de Palamós",2.41612902283669
"17501","Sant Esteve d'en Bas",37.6230739355087
"17516","Sant Privat d'en Bas",43.3659276621682
"17517","Sant Salvador de Bianya",22.8804376721382
"17510","Palau-sacosta",29.8154512166977
"17513","Sant Daniel",12.5236909572895
"17518","Santa Eugènia de Ter",21.6947914958
"17503","Queixans",8.39817546308041
"17520","Urtx",6.10174271464348
"17521","Vilallovent",4.96031731367111
"17515","Sant Llorenç de Campdevànol",11.1111106872559
"17508","Freixenet",19.2496854066849
"17511","La Pinya",56.9401647022792
"25001","Abella de la Conca",18.1697678565979
"25002","Àger",1.63555085659027
"25003","Agramunt",3.38066267967224
"25004","Alamús",5.96008290184869
"25006","Albagès",5.60352545976639
"25007","Albatàrrec",1.58644551369879
"25008","Albesa",0
"25009","Albi",15.7657895882924
"25010","Alcanó",9.74524406790733
"25011","Alcarràs",1.57404949516058
"25012","Alcoletge",6.85068520903587
"25013","Alfarràs",1.52905201911926
"25014","Alfés",16.1997131434354
"25015","Algerri",0.160256415605545
"25016","Alguaire",0.329760909080505
"25017","Alins",21.7777786254883
"25018","Alinyà",
"25019","Almacelles",2.99251861572266
"25020","Almatret",5.53947950601578
"25021","Almenar",8.63131904602051
"25022","Alòs de Balaguer",1.14722752571106
"25023","Vilanova d'Alpicat",5.30211095884442
"25026","Altron",11.3888886769613
"25027","Anglesola",24.3253420233727
"25028","Aranyó",26.7047716319561
"25029","Arbeca",7.48234181404114
"25031","Arres",13.2645807266235
"25032","Arsèguel",29.3508768081665
"25033","Artesa de Lleida",4.03823113441467
"25034","Artesa de Segre",2.75555562973023
"25036","Aspa",13.3719614202326
"25038","Aitona",22.6443183205345
"25040","Balaguer",4.5936393737793
"25041","Barbens",0
"25042","Baronia de Rialb",15.0476060594831
"25043","Barruera",19.9161424636841
"25044","Basella",13.473160982132
"25045","Bausen",17.3684215545654
"25046","Belianes",7.81929475400183
"25047","Bellcaire d'Urgell",5.92920351028442
"25048","Bell-lloc d'Urgell",5.81896150112152
"25049","Bellmunt d'Urgell",0
"25050","Bellpuig d'Urgell",26.2846655164446
"25051","Bellver de Cerdanya",
"25052","Bellvís",6.11559152603149
"25053","Benavent de Segrià",1.16639945805073
"25054","Benés",28.5714282989502
"25055","Biosca",17.3974762984685
"25056","Bovera",19.2448348457163
"25057","Bordes (Les)",42.1361103057861
"25058","Borges Blanques",16.9697035849094
"25059","Bossost",37.8987417221069
"25060","Cabanabona",5.0505051612854
"25061","Cabó",23.6111106872559
"25063","Canejan",10.3571424484253
"25064","Castellar de la Ribera",22.4976016998291
"25065","Castellàs",29.1666660308838
"25066","Castellciutat",24.5083045959473
"25067","Castelldans",3.8989144663016
"25068","Castellnou de Seana",15.5927115353671
"25069","Castelló de Farfanya",2.46753239631653
"25070","Castellserà",0.281690150499344
"25071","Cava",24.9999990463257
"25072","Cervera",27.3376897275448
"25073","Cervià",16.2785020091317
"25074","Ciutadilla",23.2612763702869
"25075","Clariana del Cardener",22.4110156467983
"","",3.83141756057739
"25076","Cogul",13.1147841016452
"25077","Coll de Nargó",25
"25078","Corbins",4.10290224850178
"25079","Cubells",2.67379689216614
"25080","Escaló",22.9798069000244
"25081","Espluga Calva",14.6472786556591
"25082","Espot",38.5235575040182
"25083","Estach",25.4370365142822
"25084","Estaon",17.2384672760963
"25085","Estaràs",23.4197121620178
"25086","Esterri d'Àneu",28.1477530797323
"25087","Esterri de Cardós",16.9642848968506
"25088","Estimariu",24.8853206634522
"25089","Farrera",22.4715200662613
"25090","Figols",28.0477027893066
"25091","Florejacs",22.1662402834211
"25092","Floresta",19.0073133977977
"25093","Fondarella",8.88279559877184
"25094","Foradada",16.5213892459869
"25095","Fórnols",25.3125
"25096","Fuliola",1.47874307632446
"25097","Fulleda",7.14785733819008
"25099","Golmés",3.15468104349242
"25100","Gósol",18.6083011627197
"25101","Granadella",16.7167256745425
"25102","Granja d'Escarp",3.18555395305157
"25103","Granyanella",22.9234352305532
"25104","Granyena de Cervera",29.907120513916
"25105","Granyena de les Garrigues",8.69921516288411
"25106","Guàrdia d'Ares",12.5
"25107","Guàrdia de Noguera",25.8620681762695
"25108","Guils",28.5642566680908
"25109","Guimerà",28.031477189064
"25110","Guissona",19.9140656335013
"25111","Guixers",21.945761680603
"25112","Ivars de Noguera",13.7244673371315
"25113","Ivars de Urgel",2.48508954048157
"25114","Iborra",28.0717958722796
"25116","Josa de Cadí",10.4106813073158
"25117","Jou",37.2322692871094
"25118","Juncosa",35.4097678444602
"25119","Juneda",5.29103154606289
"25120","Lleida",8.50033905506134
"25121","Lés",28.3397119045258
"25122","Linyola",1.26002287864685
"25123","Lladorre",14.0018601417542
"25124","Lladurs",12.6049867187228
"25125","Llardecans",25.7258165532892
"25126","Llavorsí",13.4856694340706
"25127","Lles",21.332950592041
"25128","Llimiana",
"25129","Llobera",16.5070919394493
"25130","Maldà",39.4011049800449
"25131","Massalcoreig",4.002340240912
"25132","Massoteres",24.2543290138245
"25133","Maials",4.82981987433
"25134","Menàrguens",0.634517788887024
"25135","Miralcamp",11.1097650859091
"25136","Molsosa",21.9796870776585
"25137","Mollerussa",18.5280225753784
"25138","Montgai",3.40909099578857
"25139","Montellà de Cadí",24.8917751312256
"25141","Montoliu de Segarra",22.0415335655212
"25142","Montoliu de Lleida",15.550951745775
"25143","Montornés de Segarra",31.9060543113285
"25144","Mur",
"25145","Nalec",22.4244831681252
"25146","Navès",15.5196721553803
"25147","Noves de Segre",
"25148","Odèn",20.2851087450981
"25149","Oliana",19.7981130055019
"25150","Oliola",2.1097047328949
"25151","Olius",13.7557911157608
"25152","Oluges",24.7873702049255
"25153","Omellons",5.67743795258658
"25154","Omells de na Gaia",17.2758731842041
"25155","Organyà",29.1555557250977
"25156","Os de Balaguer",19.5187158584595
"25157","Ossó de Sió",23.1356327268812
"25158","Palau d'Anglesola",5.21864424149195
"25159","Palau de Noguera",65.5172424316406
"25160","Pallargues",26.7061773359776
"25162","Pallerols del Cantó",15.1881721019745
"25163","Pedra i la Coma",17.9847209794181
"25164","Penelles",0
"25165","Peramola",21.6473223822457
"25166","Pinell del Solsonès",13.7979758466993
"25167","Pinós",25.1789659659068
"25169","Pobla de Cérvoles",13.2256414429708
"25170","Pobla de la Granadella",8.43364487588406
"25171","Pobla de Segur",13.3986930847168
"25172","Ponts",23.8451026280721
"25173","Pont de Suert",25.1476118564606
"25174","Portella",0
"25175","Prats i Sampsor",25
"25176","Preixana",27.0913350105286
"25177","Preixens",1.54639172554016
"25178","Prenyanosa",36.1901383929782
"25179","Prullans",10.5263156890869
"25180","Puiggròs",8.24372747209337
"25181","Puigverd d'Agramunt",0
"25182","Puigverd de Lleida",6.85693270630307
"25183","Rialp",4.34926983714104
"25184","Ribera de Cardós",15.1094275712967
"25186","Riner",14.6969455480576
"25187","Riu",29.4871788024902
"25188","Rocafort de Vallbona",20.3405190043979
"25189","Roselló",6.45454201102257
"25190","Salàs",26.5402851104736
"25191","Sanaüja",22.1723459788731
"25192","Freixanet",29.7856038093567
"25193","Sant Llorenç de Morunys",18.8769788912364
"25195","Sant Antolí i Vilanova",26.8553085803986
"25196","Sant Esteve de la Sarga",
"25197","Sant Guim de la Plana",30.4473401137761
"25198","Sant Martí de Maldà",23.644971433613
"25199","Sant Pere dels Arquells",21.0954368829727
"25200","Sarroca",16.3960240970958
"25201","Sarroca de Bellera",17.6470584869385
"25202","Senterada",13.6763893961906
"25203","Seu d'Urgell",22.9292507171631
"25204","Seròs",4.96614422581413
"25205","Sidamunt",8.19716758198208
"25206","Soleràs",14.565549286929
"25207","Solsona",14.174268913269
"25208","Soriguera",13.3144947290421
"25209","Sort",11.3659799098969
"25210","Soses",12.8729533918879
"25211","Sudanell",3.49830779764387
"25212","Sunyer",4.87551559342278
"25213","Suterranya",64.6153869628906
"25214","Taús",25.122950553894
"25215","Talarn",60.9022560119629
"25216","Talavera",29.2491312861443
"25217","Tàrrega",27.0617667641491
"25218","Tarrés",15.3541719615459
"25219","Tarroja",25.4014845371246
"25220","Térmens",6.66666650772095
"25221","Tírvia",0
"25222","Tiurana",21.8334843090602
"25223","Torà de Riubregós",22.5825975963048
"25224","Torms",19.5563586817847
"25225","Tornabous",0.329489290714264
"25226","Torrebesses",7.53248618841171
"25227","Torre de Capdella",17.5576235055924
"25228","Torrefarrera",9.69917265574137
"25229","Torrefeta",20.8333686113358
"25230","Torregrossa",7.9976048886776
"25231","Torrelameu",0
"25232","Torres de Segre",5.8778619224375
"25233","Torreserona",4.31799852848053
"25234","Tremp",29.0997951030731
"25235","Tudela de Segre",0.956937789916992
"25236","Tuxent",7.95454549789429
"25237","Unarre",31.3582197825114
"25238","Vallbona de las Monges",28.8911830544472
"25240","Vallfogona de Balaguer",2.67639899253845
"25241","Vansa (La)",30.7647399902344
"25242","Verdú",27.907833133425
"25244","Vilagrasa",24.5019294023514
"25245","Vilaller",30.4949150085449
"25246","Vilamitjana",44.3396224975586
"25247","Vilamós",19.2748804092407
"25248","Vilanova de Bellpuig",23.2636527485318
"25249","Vilanova de l'Aguda",22.1103177751814
"25250","Vilanova de Meià",0
"25251","Vilanova de Segrià",9.31372547149658
"25253","Vilosell",14.9039684208957
"25254","Vilanova de la Barca",2.46219209829966
"25255","Vinaixa",4.47535134987398
"25536","Éller",12.5
"25582","Talltendre",16.2634408473969
"25507","Músser i Arànser",9.92907774448395
"25594","Villec i Estana",25
"25551","Llanera del Solsonès",22.0152503422328
"25504","Anyà",0.502512574195862
"25520","Baldomar",2.67639899253845
"25516","Avellanes",21.3441896438599
"25572","Santa Linya",27.6666674613953
"25521","Baronia de la Vansa",2.48138952255249
"25526","Camarasa",23.8368651866913
"25543","Fontllonga",37.8973160982132
"25587","Tragó de Noguera",0.576923072338104
"25585","Tossal",1.26582276821137
"25573","Santa Maria de Meià",8.03212833404541
"25555","Manresana",17.5748657839639
"25566","Portell",17.6652950559344
"25534","Donzell d'Urgell",0.757575750350952
"25531","Claravalls",26.7206011772156
"25542","Figuerosa",29.9590178489685
"25581","Talladell",33.896865272522
"25500","Alàs",25.6130266189575
"25503","Anserall",20.6632652282715
"25505","Arabell",28.1226053237915
"25509","Arcavell",25.5555553436279
"25511","Arfa",25.0846633911133
"25512","Aristot",32.7652530670166
"25514","Ars",9.00501656532288
"25524","Bescaran",28.7962970733643
"25527","Castellbó",20.2525253295898
"25575","Cerc",29.3774318695068
"25544","Gavarra",15.7836623873029
"25558","Montanissell",
"25562","Parròquia d'Hortó",22.6686515808106
"25564","Pla de Sant Tirs",30.9999990463257
"25583","Toloriu",14.8745515346527
"25586","Tost",32.5396814346314
"25590","Vall de Castellbó",27.2442483901978
"25506","Aramunt",
"25529","Civís",25.4513893127441
"25523","Benavent de la Conca",10.5263156890869
"25532","Claverol",9.81954908370972
"25569","Sant Serni",
"25565","Pobleta de Bellveí",17.8535785675049
"25576","Serradell",24.8677253723145
"25508","Aransis",63.3027534484863
"25570","Sant Romà d'Abella",41.8803405761719
"25571","Sant Salvador de Toló",7.94702005386353
"25596","Viu de Llevata",20.5581393241882
"25533","Conques",20.5581393241882
"25541","Figuerola d'Orcau",
"25550","Isona",4.91367864608765
"25560","Orcau",34.9119758605957
"25561","Hortoneda de la Conca",39.7971858978272
"25557","Mont-ros",16.8273402452469
"25540","Espluga de Serra",
"25538","Eroles",
"25535","Durro",48.0141849517822
"25548","Gurp",59.8214302062988
"25552","Llesp",36
"25554","Malpàs",44.375
"25574","Sapeira",20.5357151031494
"25517","Ainet de Besan",12.5
"25510","Areu",0
"25519","Bahent",8.62068939208984
"25537","Enviny",12.2354287207127
"25546","Gerri de la Sal",12.8099174499512
"25549","Isil",35.7949924468994
"25553","Llessui",20.6453011035919
"25556","Moncortès",18.8006887435913
"25559","Norís",6.25
"25563","Peramea",18.1242332458496
"25584","Tor",21.0256404876709
"25577","Son",24.5180428822835
"25578","Sorpe",20
"25579","Surp",4.48614132404327
"25589","València d'Àneu",29.1822557449341
"25515","Arties",28.8235301971436
"25518","Bagerque",48.6677122116089
"25525","Betlan",17.3306074142456
"25539","Escunyau",47.0034246444702
"25545","Gausac",50.9643592834473
"25547","Gessa",11.6892910003662
"25568","Salardú",16.8918919563294
"25588","Tredós",45.8074541091919
"25591","Vielha",33.9131803512573
"25593","Vilac",35.8876123428345
"25513","Arrós i Vila",39.6920289993286
"43001","Aiguamúrcia",2.88366124033928
"43002","Albinyana",1.97436654567719
"43003","Albiol",30.8329755238124
"43004","Alcanar",15.9959288293665
"43005","Alcover",22.11078112466
"43006","Aldover",15.6162863327907
"43007","Aleixar",17.49791095938
"43008","Alfara",14.2459671497345
"43009","Alforja",20.0936828613281
"43010","Alió",9.38325299535479
"43011","Almoster",30.8343621662685
"43012","Altafulla",12.7246526579062
"43013","Ametlla",14.6040945269845
"43014","Amposta",14.1455933039005
"43015","Arbolí",12.4389401486045
"43016","Arboç",0.437956213951111
"43017","Argentera",18.1055032454039
"43018","Arnes",16.9013645865701
"43019","Ascó",21.4857159614563
"43020","Banyeres",1.80697149038315
"43021","Barberà",3.61268937401474
"43022","Batea",13.8103400886059
"43023","Bellmunt",21.9904838863172
"43024","Bellvei",0.234741777181625
"43025","Benifallet",15.1566704511643
"43026","Benissanet",7.76856033802033
"43027","Bisbal de Falset",31.926943397522
"43028","La Bisbal del Penedès",1.26245123147965
"43029","Blancafort",16.6764695644379
"43030","Bonastre",4.1052303314209
"43031","Borges del Camp",33.3455689112345
"43032","Bot",19.2282673835754
"43033","Botarell",15.1093126296997
"43034","Bràfim",20.406796336174
"43035","Cabacés",25.965108218946
"43036","Cabra",8.11678382541452
"43037","Calafell",3.89979338645935
"43038","Cambrils",9.57150496641795
"43039","Capafons",17.4964468917426
"43040","Capçanes",16.0994359521489
"43041","Caseres",14.7771250009537
"43042","Castellvell",27.5080867767334
"43043","Catllar",3.247879276673
"43044","Sènia",16.2948296620296
"43045","Colldejou",22.0158425807953
"43046","Conesa",17.8145121335983
"43047","Constantí",11.6268423100313
"43048","Corbera",19.6648615956307
"43049","Cornudella",8.89623557893854
"43050","Creixell",9.83397058149179
"43051","Cunit",0
"43052","Xerta",9.87173001582806
"43053","Duesaigües",13.9163754864743
"43054","l'Espluga de Francolí",23.7734142392874
"43055","Falset",20.7497315908733
"43056","Fatarella",24.9701413154602
"43057","Febró",19.8151130199432
"43058","Figuera",20.9130503177643
"43059","Figuerola",16.3782887458801
"43060","Flix",32.4897188186646
"43061","Forès",17.0161488850911
"43062","Freginals",12.5585600412809
"43063","Galera",17.6130917530793
"43064","Gandesa",10.2593028724194
"43065","Garcia",21.6191902160645
"43066","Garidells",14.0564733913967
"43067","Ginestar",8.32425320148468
"43068","Godall",11.1653368702302
"43069","Gratallops",13.7463504891647
"43070","Guiamets",13.46696820524
"43071","Horta de Sant Joan",17.5143913789229
"43072","Lloar",23.8973503828049
"43073","Llorac",17.6041376988093
"43074","Llorenç",7.94967985153198
"43075","Margalef",35.4387713432312
"43076","Marçà",33.7206667849892
"43077","Mas de Barberans",13.830460860179
"43078","Masdenverge",13.6200802142804
"43079","Masllorenç",2.26082161068916
"43080","Masó",13.3904207774571
"43081","Maspujols",39.1215073903402
"43082","Masroig",19.5990746498108
"43083","Milà",25.3514744894845
"43084","Miravet",5.90838368237019
"43085","Molar",40.2709325489245
"43086","Montblanc",20.4136150905064
"43087","Montbrió de la Marca",15.979841709137
"43088","Montbrió de Tarragona",15.037813727061
"43089","Montferri",6.39361715316773
"43090","Montmell",1.62518993020058
"43091","Mont-ral",33.0476049184799
"43092","Mont-roig",24.4573524475098
"43093","Móra d'Ebre",16.316256082058
"43094","Móra la Nova",15.1925234794617
"43095","Morell",11.7540111442407
"43096","Morera",18.5862917900085
"43097","Nou",14.952344973882
"43098","Nulles",19.3318748474121
"43099","Palma",36.8024988174439
"43100","Pallaresos",14.6805684566498
"43101","Passanant",17.6341253916423
"43102","Paüls",14.696225808217
"43103","Perafort",5.24460462277586
"43104","Perelló",8.6456286534667
"43105","Piles",7.20529743035634
"43106","Pinell de Brai",13.7705532670021
"43107","Pira",16.2069689886911
"43108","Pla de Cabra",26.2648717562358
"43109","La Pobla de Mafumet",19.4290571212769
"43110","Pobla de Massaluca",9.83493278026581
"43111","La Pobla de Montornès",17.230760316054
"43112","Poboleda",9.20446588491139
"43113","Pont de l'Armentera",23.556183497111
"43114","Porrera",3.63199449212928
"43115","Pradell",16.6619897704375
"43116","Prades",12.2475497201085
"43117","Prat de Compte",19.2110984060499
"43118","Pratdip",11.7114632606506
"43119","Puigpelat",20.0892635072981
"43120","Querol",20.2071402413505
"43121","Rasquera",7.47303203741709
"43122","Renau",17.3256005048752
"43123","Reus",7.17168396140138
"43124","Riba",13.3587892055512
"43125","Ribarroja",17.596665418148
"43126","Riera",23.1995765368144
"43127","Riudecanyes",11.7569815736068
"43128","Riudecols",18.3722664197286
"43129","Riudoms",19.8779654502869
"43130","Rocafort de Queralt",8.14091544491904
"43131","Roda de Berà",3.49110651016235
"43132","Rodonyà",20.7565025602068
"43133","Roquetes",12.4072306522956
"43134","Rourell",18.2497296233972
"43135","Salomó",19.0983133614063
"43136","Sant Carles de la Ràpita",11.9179230446999
"43137","Sant Jaume dels Domenys",1.48305082321167
"43138","Santa Bàrbara",12.4926598622249
"43139","Santa Coloma de Queralt",7.59732685486476
"43140","Santa Oliva",10.3873652219772
"43141","Santa Perpètua",21.97691822052
"43142","Sarreal",13.6863741874695
"43143","Savallà del Comtat",16.5503856113979
"43144","Secuita",8.5125461841623
"43145","Selva del Camp",20.8646671354771
"43146","Senan",21.1726588010788
"43147","Solivella",19.7046362161636
"43148","Tarragona",8.61013127615055
"43149","Tivenys",14.3400507966677
"43150","Tivissa",17.5480061531067
"43151","Torre de Fontaubella",30.108481858906
"43152","Torre de l'Espanyol",24.4896046638489
"43153","Torredembarra",3.56052223965526
"43154","Torroja",24.8730328898681
"43155","Tortosa",10.48357741038
"43156","Ulldecona",17.6044222666667
"43157","Ulldemolins",13.4420877004925
"43158","Vallclara",18.3474369049072
"43159","Vallfogona de Riucorb",18.5212780634562
"43160","Vallmoll",13.7687577009201
"43161","Valls",16.1666402816773
"43162","Vandellòs",16.4323448181152
"43163","Vendrell",0.516952738165855
"43164","Vespella",24.0167220115662
"43165","Vilabella",25.5263463656108
"43166","Vilallonga",16.7998805727278
"43167","Vilanova d'Escornalbou",14.1803481202377
"43168","Vilanova de Prades",13.941820314056
"43169","Vilaplana",20.8685016532739
"43170","Vila-rodona",11.0424547195435
"43171","Vilaseca",11.8457856178284
"43172","Vilaverd",14.2006450210299
"43173","Vilella alta",4.36815804870505
"43174","Vilella baixa",8.06026591752705
"43175","Vilalba dels Arcs",18.6512371778488
"43176","Vimbodí",1.89046166464686
"43177","Vinebre",20.6936687469482
"43178","Vinyols",14.1389238754908
"43507","Sant Vicenç de Calders",2.97905230522156
"43508","Tamarit",20.1575242877007
"43500","La Canonja",13.4290958344936
"43502","Irles",14.7818455060323
"43505","Mussara",17.0199186642965
"43506","Rojals",31.6225924491882
"43501","Ciurana",18.5458372963799